import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';

function MuiTooltip({
    children,
    title = '',
    placement = 'top-start',
    arrow = true,
    disableHoverListener = false,
    disableTouchListener = false,
    disableFocusListener = false,
    enterDelay = 0,
    enterTouchDelay = 0,
    ...otherProps
}) {
    return (
        <Tooltip
            title={title}
            placement={placement}
            arrow={arrow}
			// display tooltip when hover, touch, focus on pc/mobile
            disableHoverListener={disableHoverListener}
            disableTouchListener={disableTouchListener}
            disableFocusListener={disableFocusListener}
            enterDelay={enterDelay}
            enterTouchDelay={enterTouchDelay}
            {...otherProps}
        >
            {children}
        </Tooltip>
    );
};

MuiTooltip.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    placement: PropTypes.oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    arrow: PropTypes.bool,
    disableHoverListener: PropTypes.bool,
    disableTouchListener: PropTypes.bool,
    disableFocusListener: PropTypes.bool,
    enterDelay: PropTypes.number,
    enterTouchDelay: PropTypes.number
};

export default MuiTooltip;